export class CreditHoldAction {
    ID: number;
    Name: string;
    Inactive?: boolean;
}

export default CreditHoldAction;